import React from 'react';
import Svg, {Line, Path} from 'react-native-svg';

type NotFoundTicketIconProps = {
  width?: number;
  height?: number;
  color?: string;
};

const NotFoundTicketIcon = ({
  width = 96,
  height = 64,
  color = '#1D4289',
}: NotFoundTicketIconProps) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 96 64" fill="none">
      {/* Main ticket shape with notches */}
      <Path
        d="M4 6C4 4.89543 4.89543 4 6 4H90C91.1046 4 92 4.89543 92 6
           V26C89.7909 26 88 28.2386 88 32C88 35.7614 89.7909 38 92 38
           V58C92 59.1046 91.1046 60 90 60H6C4.89543 60 4 59.1046 4 58
           V38C6.20914 38 8 35.7614 8 32C8 28.2386 6.20914 26 4 26
           V6Z"
        fill="none"
        stroke={color}
        strokeWidth="2"
      />

      {/* Left dashed perforation line */}
      <Line
        x1="20"
        y1="8"
        x2="20"
        y2="56"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="4 4"
      />

      {/* Right solid line */}
      <Line x1="76" y1="8" x2="76" y2="56" stroke={color} strokeWidth="2" strokeLinecap="round" />

      {/* Left eye */}
      <Path
        d="M36 24C38 25.5 41 26 43 25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />

      {/* Right eye */}
      <Path
        d="M53 25C55 26 58 25.5 60 24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />

      {/* Sad mouth */}
      <Path
        d="M38 44C43 40 53 40 58 44"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </Svg>
  );
};

export default NotFoundTicketIcon;
